import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ScheduleComponent } from './schedule/schedule.component';
import { AdminComponent } from './admin.component';
import { BudgetsComponent } from './budgets/budgets.component';
import { ClientsComponent } from './clients/clients.component';
import { ProvidersComponent } from './providers/providers.component'
import { LoginComponent } from './login/login.component';
import { AngularFireAuthGuard, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['admin', 'login']);
const redirectLoggedInToSchedule = () => redirectLoggedInTo(['admin'])
const routes: Routes =  [{
  path: '', component: AdminComponent,
  children: [
    {path: '', component: ScheduleComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin}},
    {path: 'budgets', component: BudgetsComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin}},
    {path: 'clients', component: ClientsComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin}},
    {path: 'providers', component: ProvidersComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectUnauthorizedToLogin}},
    {path: 'login', component: LoginComponent, canActivate: [AngularFireAuthGuard], data: { authGuardPipe: redirectLoggedInToSchedule}}
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
